export default __webpack_public_path__ + "static/media/honey-tequila.2513122f.png";